import styled from '@emotion/styled';
import { Typography, Grid } from '@mui/material';
import { colorPalette } from 'styles/partials/colors';

interface LineProps {
  color?: string;
  thickness?: string;
  borderRadius: string;
  size?: string;
}

export const Line = styled.div<LineProps>({}, props => ({
  background: props.color,
  borderRadius: props.borderRadius,
  height: props.thickness,
  width: props.size,
}));

export const Title = styled(Typography)({
  color: colorPalette.darkGray1,
  fontWeight: 500,
  fontSize: '16px',
});

export const Subtitle = styled(Typography)({
  color: colorPalette.darkGray1,
  fontWeight: 500,
  fontSize: '14px',
  marginLeft: '8px',
});

export const GridContainer = styled(Grid)({
  marginTop: '24px',
});

export const GridSubcontainer = styled(Grid)({
  marginTop: '20px',
});

export const HiddenButton = styled.button({
  background: 'white',
  width: '100%',
  cursor: 'pointer',
  border: 'none',
  padding: 0,
});
